<template>
  <div>
   </div>
</template>

<script>

export default {
  name: 'Info',
  props: {
    product: {type:Object, required:true}
  }
}
</script>